import { Box, Button, Spinner } from '@palmetto/palmetto-components';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { useGetOrganizationActivityQuery } from '../../services/organizations';

import { ActivityList } from './ActivityList';

export const OrganizationActivity = () => {
  const { alias } = useParams<{ alias: any }>();
  const {
    data: activity,
    isLoading: isActivityLoading,
    refetch,
    isFetching,
  } = useGetOrganizationActivityQuery({ alias });
  const handleRefresh = useCallback(() => {
    refetch();
  }, [refetch]);

  return (
    <Box display="block" childGap="sm">
      {!isActivityLoading && (
        <Box alignItems={{ base: 'stretch', tablet: 'flex-start' }} padding={{ base: '0 lg', desktop: '0' }}>
          <Button
            iconPrefix="refresh"
            variant="secondary"
            tone="neutral"
            size="sm"
            isLoading={isFetching || isActivityLoading}
            onClick={handleRefresh}
          >
            refresh
          </Button>
        </Box>
      )}
      <Box>{isActivityLoading ? <Spinner size="lg" /> : <ActivityList activities={activity?.data} />}</Box>
    </Box>
  );
};
